module.exports = __webpack_public_path__ + "static/media/03-page2.62209028.png";